import {Button} from '@dropbox/dig-components/buttons';
import {GratitudeLeader, GratitudeLeaderType} from 'client';
import {LabelText} from 'components/gratitiude/LabelText';
import ProfileCard from 'components/shared/ProfileCard';
import {useDocumentTitle} from 'hooks/useDocumentTitle';
import {t} from 'i18next';
import {useState} from 'react';

import styles from './Gratitude.module.css';
import leaderboardStyles from './Leaderboard.module.css';

const MAX_PEOPLE = 16;

export const Leaderboard = ({
  title,
  data,
  leaderType,
}: {
  title: string;
  data: GratitudeLeader[] | undefined;
  leaderType: GratitudeLeaderType;
}) => {
  const [showMore, setShowMore] = useState(false);
  const people = data ?? [];
  const visiblePeople = showMore ? people : people.slice(0, MAX_PEOPLE);
  useDocumentTitle(t('leaderboard'));

  return (
    <>
      <div className={styles.subtitle}>
        <LabelText>
          <span>{t(title)}</span>
        </LabelText>
      </div>
      {people.length > 0 && (
        <>
          <div className={leaderboardStyles.profileList}>
            {visiblePeople?.map((person: GratitudeLeader) => {
              return (
                <ProfileCard
                  key={person.user_id}
                  source={`gratitudes_${leaderType}`}
                  profile_username={person.ldap}
                  profile_photo_url={person.profile_photo_url}
                  display_name={person.name}
                  profile_info={t('gratitude_sent_received', {
                    type: leaderType === GratitudeLeaderType.SENDER ? 'sent' : 'received',
                    count: person.total,
                  })}
                />
              );
            })}
          </div>
          {!showMore && people.length > MAX_PEOPLE && (
            <Button
              className={leaderboardStyles.showMoreButton}
              variant="transparent"
              size="small"
              onClick={() => setShowMore(true)}
            >
              +{people.length - MAX_PEOPLE} {t('more')}
            </Button>
          )}
        </>
      )}
    </>
  );
};
